export const formatFullName = (firstName?: string, lastName?: string): string =>
  [firstName, lastName].filter(Boolean).join(' ');

export const formatUnknownId = (id: string | number): string =>
  id
    .toString()
    .match(/.{1,3}/g)
    ?.join('-') || id.toString();
